import { render } from "./QuiSommeNous.vue?vue&type=template&id=2e5b6c64"
import script from "./QuiSommeNous.vue?vue&type=script&lang=js"
export * from "./QuiSommeNous.vue?vue&type=script&lang=js"

import "./QuiSommeNous.vue?vue&type=style&index=0&id=2e5b6c64&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__